// extracted by mini-css-extract-plugin
export default {"root":"Info_root__tN1Pn","date":"Info_date__q4FzD","consentImage":"Info_consentImage__D4Tb2"};